/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M480 0c17.597 0 32 14.405 32 32v448c0 17.592-14.402 32-32 32H32c-17.593 0-32-14.408-32-32V32C0 14.405 14.407 0 32 0zM168.04 195.79h-66.983v211.617h66.984V195.79zm167.485-4.816c-36.277 0-57.902 20.565-66.281 34.258h-1.405l-3.512-29.442h-57.902c.652 19.16 1.405 41.08 1.405 67.813v143.754h67.585V284.35c.008-5.788.128-11.467 2.108-15.33 4.917-12.29 16.056-24.628 34.219-24.628 24.385 0 34.17 18.458 34.17 45.895v117.119h67.033V282.011c0-62.246-32.764-91.037-77.42-91.037zM134.575 104C112.948 104 99 118.395 99 136.904c0 17.806 13.949 32.853 34.872 32.853 22.328 0 36.276-15.047 36.276-32.853C169.446 118.395 156.2 104 134.574 104z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconLinkedInAlt = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconLinkedInAlt.defaultProps = {
  theme,
};
IconLinkedInAlt.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconLinkedInAlt.displayName = 'IconLinkedInAlt';
export { IconLinkedInAlt };
